// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3-HRE","rightAdornment":"Header_rightAdornment__215WN"};